import { render, staticRenderFns } from "./_bottom_01.vue?vue&type=template&id=574af876&"
import script from "./_bottom_01.vue?vue&type=script&lang=js&"
export * from "./_bottom_01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports